import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CamelcaseToSpacePipe } from './camelcase-to-space.pipe';
import { TruncatedTextPipe } from './truncated-text.pipe';
import { ImageResourcePipe } from './image-resource.pipe';
import { KycImageResourcePipe } from './kyc-image-resource.pipe';



@NgModule({
  declarations: [CamelcaseToSpacePipe, TruncatedTextPipe, ImageResourcePipe, KycImageResourcePipe],
  exports: [CamelcaseToSpacePipe, TruncatedTextPipe, ImageResourcePipe, KycImageResourcePipe],
  imports: [
    CommonModule
  ]
})
export class PipesModule { }
